import { render, staticRenderFns } from "./TwoPhaseMethodSearch.vue?vue&type=template&id=56b9f98c&scoped=true&"
import script from "./TwoPhaseMethodSearch.vue?vue&type=script&lang=js&"
export * from "./TwoPhaseMethodSearch.vue?vue&type=script&lang=js&"
import style0 from "./TwoPhaseMethodSearch.vue?vue&type=style&index=0&id=56b9f98c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b9f98c",
  null
  
)

export default component.exports